import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Pipe({name: 'statisticsTimePipe'})
export class StatisticsTimePipe implements PipeTransform {

  constructor(
    public translate: TranslateService
  ) {}

  /**
    * Átalakítja a paraméterként kapott időt a to paraméternek megfelelően
    * Ha to = 'h', akkor óra perc formátumban adja vissza
    * Ha to = 'm', akkor perc formátumban adja vissza
    *
    * @param time: number
    * @param to: string
    *
    * @return string
   */
  transform(time: number, to: string = 'h') {
    return this.translate.get(['statistic.h', 'statistic.m']).pipe(map((value) => {
      const hours = Math.floor(time / 3600),
        minutes = Math.floor((time - (hours * 3600)) / 60);

      if (to === 'h') {
        return `${hours}${value['statistic.h']} ${minutes}${value['statistic.m']}`;
      }

      return `${hours * 60 + minutes}${value['statistic.m']}`;
    }));

  }
}
